import React, { useState, useRef, useEffect } from 'react';
import { Button, Modal, ModalBody, ListGroup, ListGroupItem } from 'reactstrap';
import PropTypes from "prop-types"

import { uploadFile } from '../../helpers/fileStorage';

const Webshot = (props) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [images, setImages] = useState([]);
  const [uploading, setUploading] = useState(false);
  const videoRef = useRef(null);
  const streamRef = useRef(null);

  const toggleModal = () => {
    setModalOpen(!modalOpen);
    if (!modalOpen) {
      startPreview();
    } else {
      stopPreview();
    }
  };

  const deleteImage = (img) => {
    setImages(images.filter(image => image !== img));
  };

  const startPreview = () => {
    navigator.mediaDevices.getUserMedia({ video: true, audio: false })
      .then(stream => {
        streamRef.current = stream;
        videoRef.current.srcObject = stream;
        videoRef.current.play();
      })
      .catch(err => console.error('Error accessing camera:', err));
  };

  const stopPreview = () => {
    if (streamRef.current) {
      streamRef.current.getTracks().forEach(track => track.stop());
      streamRef.current = null;
    }
  };

  const takePicture = async () => {
    const canvas = document.createElement('canvas');
    canvas.width = videoRef.current.videoWidth;
    canvas.height = videoRef.current.videoHeight;
    canvas.getContext('2d').drawImage(videoRef.current, 0, 0);

    canvas.toBlob(async (blob) => {
      const file = new File([blob], `task-${Date.now()}.jpg`, { type: 'image/jpeg' });

      setUploading(true);
      try {
        const result = await uploadFile(file, 'task-photos');
        setImages([...images, result.url]);
      } catch (error) {
        console.error('Error uploading image:', error);
      } finally {
        setUploading(false);
      }
    }, 'image/jpeg', 0.9);
  };

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;
    video.onloadedmetadata = () => {
      video.play();
    };

    // Cleanup on unmount
    return () => {
      stopPreview();
    };
  }, []);

  return (
    <div>
      <Button color="primary" onClick={toggleModal}>Take Picture</Button>
      <Modal isOpen={modalOpen} toggle={toggleModal}>
        <ModalBody>
          <div style={{ display: 'flex' }}>
            <div style={{ width: '60%' }}>
              <video ref={videoRef} style={{ width: '400px', height: '400px' }} />
              <Button
                color="primary"
                onClick={takePicture}
                disabled={uploading}
              >
                {uploading ? 'Uploading...' : 'Take Picture'}
              </Button>
            </div>
            <ListGroup style={{ width: '40%', marginLeft: '10px' }}>
              {images.map((img, index) => (
                <ListGroupItem
                  onDoubleClick={() => deleteImage(img)}
                  key={index}
                  onClick={() => {
                    props.setTaskPhotos([...props.taskPhotos, img]);
                    toggleModal();
                  }}
                >
                  <img src={img} alt="webcam preview" style={{ width: '150px', height: '150px' }} />
                </ListGroupItem>
              ))}
            </ListGroup>
          </div>
        </ModalBody>
      </Modal>
      <div>
        {props.taskPhotos && props.taskPhotos.map((img, i) => (
          <img key={i} src={img} alt="webcam preview" style={{ margin: 10, width: '150px', height: '150px' }} />
        ))}
      </div>
    </div>
  );
};

Webshot.propTypes = {
  setTaskPhotos: PropTypes.func,
  taskPhotos: PropTypes.any
};

export default Webshot;
